import { Component } from '@theme/component';

/**
 * Lets shoppers jump to the matching row in the size chart table.
 */
class SizeChartSelect extends Component {
  /**
   * Scrolls the table to the row matching the selected size.
   * @param {Event} event
   */
  scrollToRow(event) {
    const target = /** @type {HTMLSelectElement} */ (event.target);
    if (!target.value) return;

    document.getElementById(`product-size-chart-row-${target.value}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
}

if (!customElements.get('size-chart-select')) {
  customElements.define('size-chart-select', SizeChartSelect);
}
